module.exports = __webpack_public_path__ + "static/media/400106_01.daa2d326.png";